export const SUPPORTED_LOCALES = ["en", "fr", "es"] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: SupportedLocale = "en"
export const LOCALE_STORAGE_KEY = "forumone.locale"

export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value ?? "")
}

export function resolveLocale(value: string | null | undefined): SupportedLocale {
  if (isSupportedLocale(value)) return value
  return DEFAULT_LOCALE
}

export function detectBrowserLocale(): SupportedLocale {
  const lang = navigator.language?.toLowerCase() ?? ""
  if (lang.startsWith("fr")) return "fr"
  if (lang.startsWith("es")) return "es"
  return "en"
}
